import { SearchX } from 'lucide-react';
import { EtatVide, LienBouton } from '../../components/ui.tsx';

export function PageIntrouvable() {
  return (
    <EtatVide icone={<SearchX />} titre="Cette page n’existe pas"
      texte="L’adresse est peut-être incomplète, ou l’élément a été supprimé." action={<LienBouton to="/" variante="principal">Revenir à l’accueil</LienBouton>} />
  );
}
